export default "__VITE_ASSET__NksU3aur__"